import { render, staticRenderFns } from "./ClassAwayRecord.vue?vue&type=template&id=23846f64&scoped=true&"
import script from "./ClassAwayRecord.vue?vue&type=script&lang=js&"
export * from "./ClassAwayRecord.vue?vue&type=script&lang=js&"
import style0 from "./ClassAwayRecord.vue?vue&type=style&index=0&id=23846f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23846f64",
  null
  
)

export default component.exports